export const styles = theme => ({
  card: {
    flex: '1 0 20%',
    boxSizing: 'border-box',
    marginLeft: '26px',
    marginTop: '24px',
    backgroundColor: '#FFFFFF',
    height: '296px',
    [theme.breakpoints.down('xs')]: {
      marginLeft: '0px',
      maxWidth: '232px',
      minWidth: '232px'
    },
    [theme.breakpoints.up('xs')]: {
      maxWidth: '232px',
      minWidth: '232px'
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: '220px',
      minWidth: '220px'
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: '192px'
    }
  },
  cardContent: {
    height: '230px',
    '& > h3': {
      fontSize: '1.4rem'
    },
    '& > p': {
      fontSize: '0.8rem'
    }
  },
  cardActions: {
    justifyContent: 'space-around',
    height: '66px'
  },
  icon: {
    minWidth: 0
  }
});
